<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "index-content",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      contents: [],
      lesson: null,
      lessons: [],
      unit: null,
      units: [],
      branch: null,
      branches: [],
    };
  },
  components: {
    Breadcrumb,
    Dropdown
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/contents` : `/${this.gradeSlug}/content`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "المحتوى", path: this.basePath }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "المحتوى", path: `/${this.gradeSlug}/content` },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
  },
  methods: {
    fetchContents() {
      const params = this.isCourseScope ? { course_id: this.courseId } : { academic_year_id: this.gradeId };
      if (this.lesson?.id) {
        params.lesson_id = this.lesson.id;
      }

      axios
          .get('/contents', { params })
          .then((response) => {
            this.contents = response.data.data;
            // this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.contents = [];
          });
    },

    deleteContent(content_id) {
      Swal.fire({
        title: "هل تريد الحذف ؟",
        text: "سيتم نقل العنصر إلى سلة المحذوفات ويمكن استرجاعه لاحقاً.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .delete(`contents/${content_id}`)
              .then(({ data }) => {
                if (data.status == true) {
                  Swal.fire("تم الحذف بنجاح", "", "success");
                  this.contents = this.contents.filter(r => r.id !== content_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },

    async toggleHide(content) {
      const newHide = content.hide ? 0 : 1;
      try {
        await axios.post('contents/hide', {
          content_id: content.id,
          hide: newHide
        });
        content.hide = newHide;
      } catch (e) {
        // handle error (optional)
      }
    },

    onDragStart(index) {
      this.dragIndex = index;
    },
    async onDrop(targetIndex) {
      if (this.dragIndex === null || this.dragIndex === targetIndex) return;
      const moved = this.contents.splice(this.dragIndex, 1)[0];
      this.contents.splice(targetIndex, 0, moved);
      // Send only the moved lesson
      await axios.post('contents/reorder', {
        content_id: moved.id,
        order: targetIndex + 1
      });
      this.dragIndex = null;
    },


    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.branches = response.data.data; })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch?.id;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: branchId }
          : { type: 2, academic_year_id: this.gradeId, parent_id: branchId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.units = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const unitId = this.unit?.id;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: unitId }
          : { type: 3, academic_year_id: this.gradeId, parent_id: unitId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelBranch(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelUnit(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelLesson(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    this.fetchContents();
    this.fetchBranch();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <div class="row d-flex align-items-center gap-4 w-75">
          <h4 class="mb-0 col-lg-2 col-12">المحتوى</h4>
          <div class="row d-flex gap-lg-0 gap-2 col-lg-10 col-12 mb-lg-0 mb-2">
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-full md:w-14rem" @update:model-value="fetchUnits" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحده" class="w-full md:w-14rem" @update:model-value="fetchLessons" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-full md:w-14rem" @update:model-value="fetchContents" />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link :to="`${basePath}/add`" class="btn PrimaryButton">إضافة محتوى</router-link>
        </div>
      </div>
    </div>
    <div class="row reservation-table">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">الصورة</th>
              <th scope="col">العنوان</th>
              <th scope="col">الوصف</th>
              <th scope="col">الفرع الرئيسي</th>
              <th scope="col">النوع</th>
              <th scope="col">الحالة</th>
              <th scope="col">التحكم</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(content, index) in contents"
                :key="content.id"
                draggable="true"
                @dragstart="onDragStart(index)"
                @dragover.prevent
                @drop="onDrop(index)"
                style="cursor: move;"
            >
              <td data-label="ID">{{ index + 1 }}</td>
              <td data-label="الصورة">
                <img v-if="content.image" :src="content.image" alt="content Image" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;" />
                <span v-else>--- </span>
              </td>
              <td data-label="الاسم">{{ content.title }}</td>
              <td data-label="الوصف">{{ content.description }}</td>
              <td data-label="الفرع الرئيسي">{{ content.lesson ? content.lesson?.title : '---' }}</td>
              <td data-label="النوع">
                <span v-if="content.type === 'pdf'">ملف</span>
                <span v-else-if="content.type === 'video'">فيديو</span>
                <span v-else-if="content.type === 'audio'">ملف صوتي</span>
                <span v-else-if="content.type === 'exam'">امتحان</span>
              </td>
              <td data-label="الحالة">{{ content.hide ? "مخفي" : "ظاهر" }}</td>
              <td data-label="التحكم">
                <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل'"
                             flow="up"
                             :to="`${basePath}/edit/${content.id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <button
                    :class="content.hide ? 'btn btn-success' : 'btn btn-warning'"
                    @click="toggleHide(content)"
                    :tooltip="content.hide ? 'إظهار' : 'إخفاء'"
                    flow="up"
                >
                  <i :class="content.hide ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
                </button>
                <button class="btn btn-danger text-white mx-1"
                        type="button"
                        :tooltip="`حذف`"
                        flow="up"
                        @click="deleteContent(content.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="contents.length === 0">
              <td colspan="8" class="text-center">لا يوجد بيانات</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>